import React from 'react';
import axios from 'axios';
import { Segment, Loader, Checkbox, Form, Button, Dropdown, Header, Message, Divider } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { fetchAllAcademicYears } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;

export default class DiplomaStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            saving: false,
            academicYears: [],
            diplomaReviewed: false,
            promotionAcademicYearId: null,
            diplomaPrinted: false,
            earlyPrintDecisionNumber: ''
        };
    }

    componentDidMount() {
        const { studentStudyProgramId } = this.props;

        Promise.all([
            axios.get(`students/diploma-status/${studentStudyProgramId}`),
            fetchAllAcademicYears()
        ])
            .then(([diplomaRes, academicYearsRes]) => {
                const academicYears = (academicYearsRes.data || [])
                    .slice()
                    .sort((a, b) => (b.id || 0) - (a.id || 0))
                    .map(ay => ({
                        key: ay.id,
                        value: ay.id,
                        text: ay.name
                    }));

                this.setState({
                    loading: false,
                    diplomaReviewed: diplomaRes.data.diplomaReviewed || false,
                    promotionAcademicYearId: diplomaRes.data.promotionAcademicYearId || null,
                    diplomaPrinted: diplomaRes.data.diplomaPrinted || false,
                    earlyPrintDecisionNumber: diplomaRes.data.earlyPrintDecisionNumber || '',
                    academicYears
                });
            })
            .catch(() => {
                this.setState({ loading: false });
                toast('Greška pri učitavanju podataka');
            });
    }

    handleSave = () => {
        const isAdmin = this.props.admin;
        this.setState({ saving: true });
        const { studentStudyProgramId } = this.props;

        axios.put('students/diploma-status', {
            studentStudyProgramId,
            diplomaReviewed: this.state.diplomaReviewed,
            promotionAcademicYearId: this.state.promotionAcademicYearId,
            diplomaPrinted: this.state.diplomaPrinted,
            earlyPrintDecisionNumber: this.state.earlyPrintDecisionNumber
        })
            .then(() => {
                this.setState({ saving: false });
                toast('Podaci uspješno sačuvani');
            })
            .catch(() => {
                this.setState({ saving: false });
                toast('Greška pri čuvanju podataka');
            });
    };

    render() {
        if (this.state.loading) {
            return (
                <div style={{
                    paddingTop: '50px',
                    paddingBottom: '50px'
                }}>
                    <Loader active inline="centered"/>
                </div>
            );
        }

        const {
            studentService,
            admin,
            limitation,
        } = this.props;

        return (
            <Segment.Group>
                <Segment>
                    {
                        !limitation ?
                            <Message>
                                Izvršite zaključavanje studenta da biste mogli popuniti ove podatke.
                            </Message> :
                            (this.state.diplomaPrinted && studentService) &&
                            <Message>
                                Podaci su zaključani jer je diploma odštampana. Ako trebate izvršiti izmjene, molimo kontaktirajte administratora sistema.
                            </Message>
                    }
                    <Form>
                        <Form.Field>
                            <Checkbox
                                label="Diploma i dodatak diplomi na oba jezika su pregledani i spremni za štampanje od strane studentske službe."
                                checked={this.state.diplomaReviewed || false}
                                onChange={(e, { checked }) => this.setState({ diplomaReviewed: checked })}
                                disabled={(!studentService) || this.state.diplomaPrinted || !limitation}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Godina na kojoj student ide na promociju</label>
                            <Dropdown
                                search
                                selection
                                clearable
                                options={this.state.academicYears}
                                value={this.state.promotionAcademicYearId}
                                placeholder="Izaberite akademsku godinu"
                                onChange={(e, { value }) => this.setState({ promotionAcademicYearId: value })}
                                disabled={(!studentService && !admin) || this.state.diplomaPrinted || !limitation}
                            />
                        </Form.Field>
                        {studentService && !this.state.diplomaPrinted && limitation && (
                            <Button
                                primary
                                loading={this.state.saving}
                                onClick={this.handleSave}
                            >
                                Sačuvaj
                            </Button>
                        )}
                    </Form>
                </Segment>
                <Segment secondary>
                    <Divider horizontal style={{
                        marginTop: 0,
                        padding: 0
                    }}>
                        <Header as={'h5'}>
                            Ove podatke popunjava isključivo administrator eUNSA sistema.
                        </Header>
                    </Divider>
                    <Form>
                        <Form.Field>
                            <Checkbox
                                label="Odštampano"
                                checked={this.state.diplomaPrinted || false}
                                onChange={(e, { checked }) => this.setState({ diplomaPrinted: checked })}
                                disabled={!admin}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Broj odluke za prijevremeno štampanje</label>
                            <Form.Input
                                value={this.state.earlyPrintDecisionNumber || ''}
                                placeholder="Unesite broj odluke"
                                onChange={(e, { value }) => this.setState({ earlyPrintDecisionNumber: value })}
                                disabled={!admin}
                            />
                        </Form.Field>
                        {admin && (
                            <Button
                                primary
                                loading={this.state.saving}
                                onClick={this.handleSave}
                            >
                                Sačuvaj
                            </Button>
                        )}
                    </Form>
                </Segment>
                <ToastContainer hideProgressBar={true}/>
            </Segment.Group>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/DiplomaStatus.js